import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';

import {Translate} from 'views/module';

import {AddCircleOutline as AddCircleOutlineIcon} from 'views/icons';

import AddClient from './AddClient';
import ClientView from './ClientView';

const ClientConnection = (props) => {
  const [model, setModel] = React.useState({});

  const caregiverData = props.caregiverData;
  const caregiverBackend = props.caregiverBackend;

  const clients = caregiverData.clients;

  const openDialogs = {
    close: () => {
      setModel({});
    },
    addClient: () => {
      setModel({action: 'ADD_CLIENT'});
    },
  };

  const edits = {
    addClient: (clientRn) => {
      const complete = () => {
        setModel({});
      };

      caregiverBackend.detail.addClient(clientRn, complete);
    },
    removeClient: (clientRn) => {
      const complete = () => {
        setModel({});
      };

      caregiverBackend.detail.removeClient(clientRn, complete);
    },
  };

  const popModelGenerator = React.useCallback(() => {
    let popModel = null;
    if (model.action === 'ADD_CLIENT') {
      popModel = <AddClient
        onClose={openDialogs.close}
        addClient={edits.addClient}
      />;
    }
    return popModel;
  }, [model]);

  return (
    <Stack
      sx={{
      }}
    >
      {popModelGenerator()}
      {
        Object.values(clients).map((e, index) => {
          return (
            <ClientView
              key={index}
              client={e}
              removeClient={edits.removeClient}
            />
          );
        })
      }
      <Button
        startIcon={<AddCircleOutlineIcon />}
        onClick={openDialogs.addClient}
        sx={{
          mx: 2,
          my: 1,
        }}
      >
        <Translate expression='caregiver.CaregiverDetail.ClientConnections.AddClient.Title' />
      </Button>
    </Stack>
  );
};

ClientConnection.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};
export default React.memo(ClientConnection);
